<template>
  <div style="padding: 15px;">
    <header>
      <h2>{{ $t('modification.title') }}</h2>
      <a-space>
        <a-range-picker style="margin-right: 10px;" v-model="dateRange" />
        <a-button type="primary" @click="searchOutTable">{{ $t('buttons.search') }}</a-button>
      </a-space>
    </header>
    <el-table
      style="margin-top: 15px;"
      v-loading="loading"
      :data="records"
    >
      <el-table-column>
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('user.columns.name') }}</div>
          <a-input allow-clear v-model.trim="outParameters.query[0].value" @keyup.enter="searchOutTable" />
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="outHighlightInfo.realName">{{ scope.row.realName }}</text-highlight>
        </template>
      </el-table-column>
      <el-table-column>
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('user.columns.mobile') }}</div>
          <a-input allow-clear v-model.trim="outParameters.query[1].value" @keyup.enter="searchOutTable" />
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="outHighlightInfo.username">{{ scope.row.username }}</text-highlight>
        </template>
      </el-table-column>
      <el-table-column>
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('user.columns.organization') }}</div>
          <a-input allow-clear v-model.trim="outParameters.query[2].value" @keyup.enter="searchOutTable" />
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="outHighlightInfo.organizationName">{{ scope.row.organizationName }}</text-highlight>
        </template>
      </el-table-column>
      <el-table-column>
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('user.columns.role') }}</div>
          <a-input allow-clear v-model.trim="outParameters.query[3].value" @keyup.enter="searchOutTable" />
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="outHighlightInfo.roleName">{{ scope.row.roleName }}</text-highlight>
        </template>
      </el-table-column>
      <el-table-column width="150">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('modification.count') }}<span @click="changeSortParameter($event, 'modificationCnt')" class="icons DESC" style="cursor: pointer;" data-index="code">
            <a-icon type="caret-up" />
            <a-icon type="caret-down" />
          </span></div>
          <a-input-number style="width: 100%" allow-clear v-model="modificationCnt" @keyup.enter="searchOutTable" />
        </template>
        <template slot-scope="scope">
          {{ scope.row.modificationCnt }}
        </template>
      </el-table-column>
      <el-table-column width="120">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('common.operation') }}</div>
        </template>
        <template slot-scope="scope">
          <a-button type="link" style="padding-left: 0;" @click="showDetailsModal(scope.row)">{{ $t('modification.details') }}</a-button>
          <!-- <text-highlight v-else :queries="highLightInfo[0].value">{{ scope.row.code }}</text-highlight> -->
        </template>
      </el-table-column>
    </el-table>
    <footer>
      <a-pagination @change="handlePageChange" style="float: right; margin-top: 15px;" :current="current" :pageSize="pageSize" :total="total" hideOnSinglePage />
    </footer>
    <a-modal v-model="visible" :title="$t('modification.details')" @cancel="visible = false" :width="1200" :footer="null" :afterClose="clearSearchInfo">
      <el-table
        :height="550"
        :data="details"
        v-loading="innerTableLoading"
      >
        <el-table-column>
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('modification.user') }}</div>
          </template>
          <template slot-scope>
            {{ realName }}
          </template>
        </el-table-column>
        <el-table-column width="150">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('saleDocument.updateTime') }}</div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.time }}
          </template>
        </el-table-column>
        <el-table-column width="130">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('common.deviceCode') }}</div>
            <a-input allow-clear v-model.trim="innerParameters.deviceCode" @keyup.enter="searchInnerTable" />
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="innerHighlightInfo.deviceCode">{{ scope.row.deviceCode }}</text-highlight>
          </template>
        </el-table-column>
        <el-table-column width="120">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('common.deviceName') }}</div>
            <a-input allow-clear v-model.trim="innerParameters.deviceName" @keyup.enter="searchInnerTable" />
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="innerHighlightInfo.deviceName">{{ scope.row.deviceName }}</text-highlight>
          </template>
        </el-table-column>
        <el-table-column width="120">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('common.protocolCode') }}</div>
            <a-input allow-clear v-model.trim="innerParameters.protocolCode" @keyup.enter="searchInnerTable" />
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="innerHighlightInfo.protocolCode">{{ scope.row.protocolCode }}</text-highlight>
          </template>
        </el-table-column>
        <el-table-column width="150">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('modification.points') }}</div>
            <a-input allow-clear v-model.trim="innerParameters.pointName" @keyup.enter="searchInnerTable" />
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="innerHighlightInfo.pointName">{{ scope.row.pointName }}</text-highlight>
          </template>
        </el-table-column>
        <el-table-column>
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('device.value') }}</div>
            <a-input allow-clear v-model.trim="innerParameters.value" @keyup.enter="searchInnerTable" />
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="innerHighlightInfo.value">{{ scope.row.value }}</text-highlight>
          </template>
        </el-table-column>
        <el-table-column width="130">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('common.deviceType') }}</div>
            <a-select style="width: 100%;" v-model="innerParameters.deviceType" @change="searchInnerTable">
              <a-select-option value="">
                {{ $t('common.all') }}
              </a-select-option>
              <a-select-option v-for="(v, k) in deviceTypeMap" :key="k">
                {{ v }}
              </a-select-option>
            </a-select>
          </template>
          <template slot-scope="scope">
            {{ deviceTypeMap[scope.row.deviceType] }}
          </template>
        </el-table-column>
        <el-table-column width="110">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('common.model') }}</div>
            <a-input allow-clear v-model.trim="innerParameters.deviceModel" @keyup.enter="searchInnerTable" />
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="innerHighlightInfo.deviceModel">{{ scope.row.deviceModel }}</text-highlight>
          </template>
        </el-table-column>
        <el-table-column width="100">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('common.dtuCode') }}</div>
            <a-input allow-clear v-model.trim="innerParameters.dtuCode" @keyup.enter="searchInnerTable" />
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="innerHighlightInfo.dtuCode">{{ scope.row.dtuCode }}</text-highlight>
          </template>
        </el-table-column>
        <el-table-column width="230">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('common.customer') }}</div>
            <a-input allow-clear v-model.trim="innerParameters.company" @keyup.enter="searchInnerTable" />
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="innerHighlightInfo.company">{{ scope.row.company }}</text-highlight>
          </template>
        </el-table-column>
      </el-table>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import TextHighlight from 'vue-text-highlight'
import {
  getDeviceModificationCnt,
  getDeviceModificationDetail
} from '@/api/SystemLog'
import { getDict } from "@/api/dict"

export default {
  components: {
    TextHighlight
  },
  data() {
    return {
      current: 1,
      pageSize: 10,
      total: 0,
      dateRange: null,
      loading: false,
      outParameters: {
        query: [
          {
            field: 'realName',
            value: ''
          },
          {
            field: 'username',
            value: ''
          },
          {
            field: 'organizationName',
            value: ''
          },
          {
            field: 'roleName',
            value: ''
          }
        ],
        filter: [],
        sort: [
          {
            field: 'modificationCnt',
            value: 'desc'
          }
        ]
      },
      modificationCnt: undefined,
      realName: '',
      outHighlightInfo: {
        realName: '',
        username: '',
        organizationName: '',
        roleName: ''
      },
      innerParameters: {
        deviceCode: '',
        deviceName: '',
        protocolCode: '',
        pointName: '',
        value: '',
        deviceModel: '',
        dtuCode: '',
        company: '',
        deviceType: ''
      },
      innerHighlightInfo: {
        deviceCode: '',
        deviceName: '',
        protocolCode: '',
        pointName: '',
        value: '',
        deviceModel: '',
        dtuCode: '',
        company: ''
      },
      records: [],
      details_origin: [],
      details: [],
      visible: false,
      deviceTypeMap: {},
      innerTableLoading: false
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang() {
      this.setDeviceTypeMap()
    }
  },
  activated() {
    this.dateRange = [
      moment(+new Date()),
      moment(+new Date())
    ]
  },
  created() {
    this.dateRange = [
      moment(+new Date()),
      moment(+new Date())
    ]
    this.setDeviceTypeMap()
    this.searchOutTable()
  },
  methods: {
    setTime() {
      const s = new Date(this.dateRange[0]._d)
      const e = new Date(this.dateRange[1]._d)
      this.startTime = +new Date(s.setHours(0, 0, 0, 0))
      this.endTime = new Date(e.setDate(e.getDate() + 1)).setHours(0, 0, 0, 0) - 1
    },
    async searchOutTable() {
      if (!this.dateRange) return this.$message.warn(this.$t('placeholder.timeRange'))
      this.setTime()
      if (this.modificationCnt || this.modificationCnt === 0) {
        this.outParameters.filter = [
          {
            field: 'modificationCnt',
            value: this.modificationCnt,
            req: 'ge'
          }
        ]
      } else {
        this.outParameters.filter = []
      }
      try {
        this.loading = true
        const { data } = await getDeviceModificationCnt({
          current: this.current,
          pageSize: this.pageSize,
          startTime: this.startTime,
          endTime: this.endTime
        }, this.outParameters)
        this.total = data.total
        this.records = data.records
        for (let i = 0; i < this.outParameters.query.length; i++) {
          this.outHighlightInfo[this.outParameters.query[i].field] = this.outParameters.query[i].value
        }
      } catch(e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    },
    handlePageChange(p) {
      this.current = p
      this.searchOutTable()
    },
    async showDetailsModal(r) {
      this.visible = true
      this.realName = r.realName
      try {
        const { data } = await getDeviceModificationDetail({
          userId: r.userId,
          startTime: this.startTime,
          endTime: this.endTime
        }, this.innerParameters)
        this.details_origin = this.details = data.map(d => {
          d.time = moment(+d.time).format('YYYY-MM-DD HH:mm:ss')
          return d
        })
      } catch(e) {
        console.log(e)
      }
    },
    changeSortParameter(e, field) {
      let node = e.target
      while (node.nodeName !== 'SPAN') {
        node = node.parentNode
      }
      let c = "";
      switch (node.classList[1]) {
        case "ASC":
          c = "DESC"
          break
        case "DESC":
          c = "unset"
          break
        case "unset":
          c = "ASC"
          break
        default:
          break
      }
      node.classList.remove(node.classList[1])
      node.classList.add(c)
      const targetIndex = this.outParameters.sort.findIndex(s => s.field === field)
      if (c === 'unset') {
        if (targetIndex > -1) {
          this.outParameters.sort.splice(targetIndex, 1)
        }
      } else {
        if (targetIndex > -1) {
          this.outParameters.sort[targetIndex].value = c
        } else {
          this.outParameters.sort.push({
            field,
            value: c
          })
        }
      }
      this.searchOutTable()
    },
    searchInnerTable() {
      this.innerTableLoading = true
      let i = 0, result = [], flag
      for (i; i < this.details_origin.length; i++) {
        for (let key in this.innerParameters) {
          if (this.details_origin[i][key].includes(this.innerParameters[key])) {
            flag = true
          } else {
            flag = false
            break
          }
        }
        if (flag) {
          result.push(this.details_origin[i])
        }
      }
      this.details = result
      for (let key in this.innerParameters) {
        this.innerHighlightInfo[key] = this.innerParameters[key]
      }
      this.innerTableLoading = false
    },
    async setDeviceTypeMap() {
      const lang = this.lang === 'en' ? 'en-US' : 'zh-CN'
      const deviceTypeMap = {}
      try {
        const { data } = await getDict(lang, 'deviceType')
        data.content.forEach(c => {
          deviceTypeMap[c.value] = c.text
        })
        this.deviceTypeMap = deviceTypeMap
      } catch(e) {
        console.log(e)
      }
    },
    clearSearchInfo() {
      for (let key in this.innerParameters) {
        this.innerParameters[key] = this.innerHighlightInfo[key] = ''
      }
    }
  }
}
</script>

<style lang="less" scoped>
header {
  display: flex;
  justify-content: space-between;
}
div {
  position: relative;
}
span {
  position: relative;
}
.anticon-caret-up {
  position: absolute;
  top: -1px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
span.ASC .anticon-caret-up {
  color: #1890ff;
}
span.icons {
  position: absolute;
  right: 18px;
}
span.DESC .anticon-caret-down {
  color: #1890ff;
}
.anticon-caret-down {
  position: absolute;
  top: 8px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
.innerTable {
  width: 95%;
  margin: 0 auto;
}
/deep/ .ant-select-selection__rendered {
  font-weight: normal;
}
</style>
